


























































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {OrderProduct} from "@/model/OrderProduct";
import {Order} from "@/model/Order";
import ProductLinePanel from "@/components/orders/ProductLinePanel.vue";
import {Inject} from "vue-typedi";
import {PriceService} from "@/services/PriceService";
import {ProductService} from "@/services/ProductService";
import {Quantity} from "@/model/Quantity";
import {PricePerUom} from "@/model/support/PricePerUom";
import {Currency} from "@/model/Currency";
import {SupportProduct} from "@/model/support/SupportProduct";
import {Price} from "@/model/Price";
import humanReadableUnit from "@/filters/UnitFormatter";
import ErrorDialog from "@/components/dialog-box/ErrorDialog.vue";
import {ConvertProductService} from "@/services/ConvertProductService";
import LoadingDialog from "@/components/dialog-box/LoadingDialog.vue";
import ScanDetector from "@/helpers/ScanDetector";
import {Support} from "@/model/support/Support";
import DialogBox from "@/components/dialog-box/DialogBox.vue";
import {ModifiedQuantity} from "@/model/order/ModifiedQuantity";

@Component({
  components: {DialogBox, LoadingDialog, ErrorDialog, ProductLinePanel },
  filters: { humanReadableUnit }
})
export default class ProductPreparation extends Vue {

  @Prop({ default: () => {} }) product: OrderProduct;
  @Prop({ default: () => {} }) editingSupportProduct: SupportProduct;
  @Prop({ default: () => {} }) order: Order;
  @Prop({ default: () => {} }) selectedSupport: Support;
  @Prop({ default: () => {} }) existingMeasures : Quantity[];

  @Inject()
  priceService!: PriceService;
  @Inject()
  productService!: ProductService;
  @Inject()
  productConverter!: ConvertProductService;

  @Watch('product', {immediate: true}) watchProductChange() { this.updateCurrentProduct(this.product); }

  beforeDestroy() {
    this.scanDetector.reset();
  }

  ERROR_MESSAGE_PRICE_API_UNAVAILABLE = "La recherche de prix a échoué. Merci de saisir les informations manuellement.";
  ERROR_MESSAGE_WRONG_PRODUCT_SCAN = "Le produit scanné ne correspond pas au produit commandé.";
  ERROR_MESSAGE_UNKNOWN_PRODUCT_SCAN = "Le produit scanné n'est pas reconnu.";
  ERROR_MESSAGE_WRONG_WEIGHT_SCAN = "Le produit scanné n'a pas de poids.";
  WEIGHT_TOLERANCE_RATIO = 0.2;

  currentProduct: OrderProduct = new OrderProduct();
  supportProduct: SupportProduct = new SupportProduct();
  currentEan: string = '';
  scanDetector: ScanDetector = new ScanDetector((value: string) => {
    this.currentEan = value;
      this.onProductScan();
  });
  pricePerMeasure: string = '';
  isPricePerMeasureEditing: boolean = false;
  measures: ProductMeasure[] = [];
  isSaving: boolean = false;
  isFetchingPrice: boolean = false;
  isProductScanned: boolean = false;
  totalMeasure: number = 0;
  hasScanError: boolean = false;
  errorMessage: string = '';
  isPricePerUomEdited: boolean = false;
  canSplitWeights: boolean = false;
  currentMeasure: string = "";
  splitQuantity: Quantity = null;
  existingPreparedQuantities: string = "";
  existingPreparedTotalMeasures: string = "";

  updateCurrentProduct(product: OrderProduct) {
    if(product) {
      this.currentProduct = product;
      this.supportProduct = this.selectedSupport.products.find(product => product.cug === this.editingSupportProduct?.cug) ?? new SupportProduct();

      this.pricePerMeasure = this.editingSupportProduct?.pricePerUom?.value?.toString() ?? "-";
      this.isPricePerMeasureEditing = false;
      this.isSaving = false;
      this.isProductScanned = false;
      this.totalMeasure = 0;
      this.scanDetector.reset();

      const quantity = product?.quantity?.value ?? 0;
      const measures = this.editingSupportProduct?.measures ?? [];

      this.measures = Array.from(
        { length: product?.quantity?.value || 0 },
        (_, i) => {
          const index = i + 1;
          return new ProductMeasure(
            index,
            measures.find(measure => measure.index === index)?.value?.toString());
        }).filter(measure => !this.existingMeasures.some(existingMeasure => existingMeasure.index === measure.index));

      this.existingPreparedQuantities = this.existingMeasures.length.toString();
      this.existingPreparedTotalMeasures = this.existingMeasures.reduce(
        (total, measure) => total + measure.value,
        0,
      ).toString();

      this.focusEanInput();
    }
  }

  isMeasureFromOtherSupport(existingMeasures: Quantity[], indexToEdit: number): boolean {
    const existsInProduct = existingMeasures.some(
      measure => measure.index === indexToEdit
    );

    const existsInCurrentSupport =
      this.supportProduct?.measures?.some(
        measure => measure.index === indexToEdit
      ) ?? false;

    return !existsInProduct || existsInCurrentSupport;
  }

  back(): void {
    this.$emit('cancel');
  }

  emitOutOfStock(): void {
    this.isSaving = false;
    this.$emit('handleOutOfStock', {
      product: this.product,
      supportProduct: this.supportProduct
    });
  }

  savePreparation(): void {
    this.proceedSave();
  }

  proceedSave(): void {
    this.isSaving = true;

    this.removeEmptyMeasures();
    this.computeProductTotals();
    if (this.hasEmptyMeasure) {
      this.emitOutOfStock();
      return;
    }

    this.isSaving = false;
    this.$emit('complete', this.supportProduct);
  }

  computeProductTotals(): void {
    this.totalMeasure = this.measures.reduce((sum, m) => sum + Number(m.value), 0) + this.existingMeasures.reduce((sum, m) => sum + Number(m.value), 0);

    this.product.variableMeasurement.totalProcessed = Math.round(this.totalMeasure * 1000) / 1000;
    this.product.totalPrice += this.totalMeasure * Number(this.pricePerMeasure);
    this.product.processedQuantity = new Quantity(
      this.measures.length,
      "piece"
    );

    this.convertOrderProductToSupportProduct();

    this.product.processedQuantity = new Quantity(
      this.measures.length + Number(this.existingPreparedQuantities),
      "piece"
    );
  }

  removeEmptyMeasures(): void {
    this.measures = this.measures.filter(measure => !this.isMeasureEmpty(measure.value));
  }

  isMeasureEmpty(value: string): boolean {
    return value === '' || value === '-' || Number(value) === 0;
  }

  convertOrderProductToSupportProduct(): void {
    this.supportProduct = this.productConverter.convertOrderProductToSupportProduct(this.product);
    this.supportProduct.measures = [];
    this.supportProduct.measures = this.measures.map(measure => new Quantity(Number(measure.value), this.product.variableMeasurement.unit, measure.index));
    this.supportProduct.pricePerUom = new PricePerUom(
      Number(this.pricePerMeasure),
      Currency.EUR,
      this.product.variableMeasurement.unit
    )
  }

  closeErrorPopUp() {
    this.hasScanError = false;
    this.errorMessage = '';
  }

  onScanInput(value: string): void {
    this.scanDetector.onInput(value);
  }

  async onProductScan(): Promise<void> {
    if (this.isFetchingPrice) {
      return;
    }

    this.isFetchingPrice = true;
    try {
      const price = await this.priceService.getPrices(this.currentEan);

      if (price.cug == null) {
        return this.showError(this.ERROR_MESSAGE_UNKNOWN_PRODUCT_SCAN);
      }

      if (Number(price.cug) !== Number(this.currentProduct.cug)) {
        return this.showError(this.ERROR_MESSAGE_WRONG_PRODUCT_SCAN);
      }

      if (!price.measuredValue) {
        return this.showError(this.ERROR_MESSAGE_WRONG_WEIGHT_SCAN);
      }

      this.applyScanResult(price);

    } catch {
      this.showError(this.ERROR_MESSAGE_PRICE_API_UNAVAILABLE);
    } finally {
      this.isProductScanned = true;
      this.isFetchingPrice = false;
      this.currentEan = '';
      this.scanDetector.reset();
      this.focusEanInput();
    }
  }

  showError(message: string): void {
    this.hasScanError = true;
    this.errorMessage = message;
  }

  applyScanResult(price: Price): void {
    if(!this.isPricePerUomEdited) {
      this.pricePerMeasure = price.pricePerUom.toString();
    }
    const measure: ProductMeasure = new ProductMeasure();
    measure.value = price.measuredValue.toPrecision(3).toString();
    measure.isEditing = false;
    if (this.isSplittableMeasure(measure)) {
      this.canSplitWeights = true;
      this.currentMeasure = measure.value;
      return;
    }
    const emptyMeasure = this.measures.find(m => m.value === '' || m.value === '-');
    if (emptyMeasure != null) {
      emptyMeasure.value = measure.value;
    }
  }

  startPricePerKiloEdit(): void {
    this.isPricePerMeasureEditing = true;
    this.focusPriceInput();
  }

  savePricePerKilo(): void {
    this.isPricePerUomEdited = true;
    this.isPricePerMeasureEditing = false;
  }

  startMeasureEdit(measure: ProductMeasure): void {
    if (!measure.canBeEdited) return;

    measure.isEditing = true;
    this.focusMeasureInput(measure);
  }

  saveMeasure(measure: ProductMeasure): void {
    measure.isEditing = false;

    if (this.product.variableMeasurement.max != null && Number(measure.value) > this.maxWeightThreshold && this.measures.length > 1) {
      this.currentMeasure = measure.value;
      measure.value = '-';
      this.canSplitWeights = true;
    }
  }

  focusEanInput() {
    this.$nextTick(() => {
      (this.$refs.eanInput as HTMLInputElement)?.focus();
    });
  }

  focusPriceInput() {
    this.$nextTick(() => {
      (this.$refs.priceInput as HTMLInputElement)?.focus();
      (this.$refs.priceInput as HTMLInputElement)?.select();
    });
  }

  focusMeasureInput(measure: ProductMeasure) {
    this.$nextTick(() => {
      const ref = this.$refs['measureInput-' + measure.index];

      if (ref instanceof HTMLInputElement) {
        ref.focus();
      } else if (Array.isArray(ref) && ref[0] instanceof HTMLInputElement) {
        ref[0].focus();
        ref[0].select();
      }
    });
  }

  isMeasureOutOfRange(measure: ProductMeasure): boolean {
    if (this.isMeasureEmpty(measure.value)) {
      return false;
    }
    return Number(measure.value) > this.maxWeightThreshold;
  }

  cancelSplitWeights(): void {
    const emptyMeasure = this.measures.find(m => m.value === '' || m.value === '-');
    if (emptyMeasure != null) {
      emptyMeasure.value = this.currentMeasure;
    }
    this.closeSplitWeightsPopup();
  }

  closeSplitWeightsPopup(): void {
    this.canSplitWeights = false;
  }

  isSplittableMeasure(measure: ProductMeasure): boolean {
    if (this.product.variableMeasurement.max == null) {
      return false;
    }

    const isHeavierThanOneQuantity = Number(measure.value) > this.maxWeightThreshold;
    const hasMultipleEmptyMeasures = this.emptyMeasures.length > 1;
    return isHeavierThanOneQuantity && hasMultipleEmptyMeasures;
  }

  updateSplitQuantity(modifiedQuantity: ModifiedQuantity): void {
    this.splitQuantity = modifiedQuantity.quantity;
    if (this.splitQuantity.value > this.emptyMeasures.length) {
      this.splitQuantity.value = this.emptyMeasures.length;
    }
  }

  applyWeightsSplit(): void {
    const total = Number(this.currentMeasure);
    const measuresToFill = this.emptyMeasures.slice(0, this.splitQuantity.value);

    if (!Number.isFinite(total) || measuresToFill.length === 0) {
      return;
    }

    const splitValue = Number((total / measuresToFill.length).toFixed(3));
    measuresToFill.forEach(measure => measure.value = splitValue.toFixed(3));

    const lastMeasure = measuresToFill[measuresToFill.length - 1];
    lastMeasure.value = (total - splitValue * (measuresToFill.length - 1)).toFixed(3);

    this.closeSplitWeightsPopup();
  }

  get maxWeightThreshold(): number {
    return this.product.variableMeasurement.max * (1 + this.WEIGHT_TOLERANCE_RATIO);
  }

  get emptyMeasures(): ProductMeasure[] {
    return this.measures.filter(m => m.value === '' || m.value === '-');
  }

  get isPriceMissing(): boolean {
    return this.isMeasureEmpty(this.pricePerMeasure) && this.hasAnyFilledMeasure;
  }

  get hasAnyFilledMeasure(): boolean {
    return this.measures.some(m => !this.isMeasureEmpty(m.value));
  }

  get isSaveDisabled(): boolean {
    return this.isSaving || this.hasOutOfRangeMeasure || this.isPriceMissing;
  }

  get hasOutOfRangeMeasure(): boolean {
    return this.measures.some(measure => this.isMeasureOutOfRange(measure));
  }

  get canSetProductOutOfStock(): boolean {
    const hasZeroMeasure = this.measures.length === 0 || this.measures.some(measure => this.isMeasureEmpty(measure.value));
    return hasZeroMeasure || this.isMeasureEmpty(this.pricePerMeasure);
  }

  get canShowProductPreparation(): boolean {
    return this.product && this.product.isScannable;
  }

  get hasEmptyMeasure(): boolean {
    return this.measures.some(m => m.value === '' || m.value === '-') || (this.measures.length + this.existingMeasures.length) < this.product.quantity.value;
  }

  get hasValidCurrentEan(): boolean {
    return this.currentEan != null && /^[0-9]+$/.test(this.currentEan.trim());
  }

  get canScanTag(): boolean {
    return this.hasEmptyMeasure && !this.isFetchingPrice && !this.canSplitWeights;
  }

  get canRegisterTag(): boolean {
    return this.canScanTag && this.hasValidCurrentEan;
  }

  get canGoBack(): boolean {
    return !this.isProductScanned;
  }

  get pricePerMeasureInput(): string {
    return this.pricePerMeasure === '-' ? '' : this.pricePerMeasure;
  }

  set pricePerMeasureInput(value: string) {
    this.pricePerMeasure = value;
  }
}

class ProductMeasure {
  index: number;
  value: string = '';
  isEditing: boolean = false;
  canBeEdited: boolean;

  constructor(index?: number, value?: string, canBeEdited = true) {
    this.index = index || 1;
    this.value = value ?? "-";
    this.canBeEdited = canBeEdited;
  }

  get inputValue(): string {
    return this.value === '-' ? '' : this.value;
  }

  set inputValue(value: string) {
    this.value = value;
  }
}
